import './app.css'
import App from './App.svelte'
import { mount } from 'svelte'

// Svelte 5: use mount() to hydrate the app
const app = mount(App, {
	target: document.getElementById('app')!
})

export default app
